
//判断是否在京麦
export function isInJm() {
    const ua = window.navigator.userAgent;
    return /JM_IOS|JM_ANDROID|MicroMessenger/i.test(ua)
}
// 是在苹果机
export function isInIOS() {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

// 是在安卓机
export function isInAndroid() {
    return navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;
}

const jmSdk = window.JmJsBridge;

/**
 * @method 获取京麦版本号
 */
const getJmVersion = () => {
  /* eslint-disable */
  // 返回京麦版本的整数值
  const ua = navigator.userAgent;
  const match = ua.match(/(JM_IOS|JM_ANDROID|JM_PC)\/([\d\.]+)/i);
  if (match) {
    return parseInt(match[2].replace(/\./g, ''));
  }
  return 0;
};

/**
 * @method 打开京麦唤起咚咚
 * @param userPin<string> 用户pin
 */
const openDongDong = (userPin, context) => {
  jmSdk && jmSdk.ready(function () {
    jmSdk.call('openDongDong', {'info': `pin=${userPin}&gid=1&type=0&isMate=false`}, function (res) {
      var result = res.result
      if (result === 'fail') {
        context.$toast.warning(res.message);
      }
    })
  });
}

/**
 * @method 扫一扫
 * @param action<Fun> 回调函数
 */
const scanNumber = (action) => {
  jmSdk && jmSdk.ready(function () {
    jmSdk.call('scanQRCode', {}, action)
  })
}

/**
 * @method 京麦复制功能
 * @param content<string> 复制内容  vm<Vue> vue实例
 */
const copyContent = (content, vm, successText = '复制成功', errorText = '复制失败') => {
  const jmVersion = getJmVersion();
  if (jmVersion > 360) {
    try {
      jmSdk.ready(() => {
        jmSdk.call('copyBoard', { content: `${content}` }, (res) => {
          const { result } = res;
          if (result === 'success') {
            vm.$toast.success(successText);
          } else {
            vm.$toast.error(errorText);
          }
        });
      });
    } catch {
      copyContentByDom(content, vm, successText, errorText);
    }
  } else {
    copyContentByDom(content, vm, successText, errorText);
  }
};

/**
 * @method 原生复制功能
 * @param content<string> 复制内容 vm<Vue> vue实例
 */
const copyContentByDom = (content, vm, successText = '复制成功', errorText = '复制失败') => {
  try {
    const aux = document.createElement('input'); // 创建元素用于复制
    aux.setAttribute('value', content); // 设置元素内容
    document.body.appendChild(aux); // 将元素插入页面进行调用
    aux.select(); // 复制内容
    // 将内容复制到剪贴板
    if (document.execCommand('copy', false, null)) {
      document.body.removeChild(aux); // 删除创建元素
      vm.$toast.success(successText);
    } else {
      document.body.removeChild(aux); // 删除创建元素
      vm.$toast.error(errorText);
    }
  } catch (err) {
    vm.$toast.error(err);
  }
};

/**
 * @method 京麦打开新url
 * @param url<string> 要打开的url地址
 */
const openNewPage = function(url) {
  if (jmSdk) {
    jmSdk.ready(function() {
      jmSdk.call('openPage', {
        url: url
      })
    })
  } else {
    window.location.href = url
  }
}

const sendLog = function(method, id, pageParam) {
  if (jmSdk) {
    jmsdk.ready(() => {
      jmsdk.call(method, {
        eventId: id,
        pageName: document.title,
        pageParam: JSON.stringify(pageParam),
        businessId: id,
      });
    });
  }
}

export {
  // setTitle,
  copyContent,
  openNewPage,
  openDongDong,
  scanNumber,
  sendLog
};
